<!-- 移动端基金持股汇总数据展示组件 -->
<template>
	<div class="fund-holding-overview">
		<div class="overview-block">
			<div v-if="showTotalHoldings" class="overview-item">
				<span class="overview-item-value">{{ computedHoldVolumeSum.value }}</span>
				<span class="overview-item-label">
					{{ $t('enterprise.total-of-holdings') }}({{ computedHoldVolumeSum.unit }})
				</span>
			</div>
			<div v-if="showPercentage" class="overview-item">
				<span class="overview-item-value">{{ roundToTwoDecimals(data.ratioSum) }}</span>
				<span class="overview-item-label">{{ $t('enterprise.percentage-of-circulating-shares') }}</span>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { formatterColTransferUnit, roundToTwoDecimals } from '@/utils/format';

// Props 定义
const props = defineProps({
	// 基金持股数据
	data: {
		type: Object,
		default: () => ({})
	},
	// 是否显示总持股数
	showTotalHoldings: {
		type: [Boolean, Number, String],
		default: true
	},
	// 是否显示流通股占比
	showPercentage: {
		type: [Boolean, Number, String],
		default: true
	}
});

// 计算总持股数
const computedHoldVolumeSum = computed(() => {
	return splitAmount(props.data?.holdVolumeSum);
});

// 格式化金额
const splitAmount = amount => {
	const [value, unit] = formatterColTransferUnit(amount, true);
	return { value, unit };
};
</script>

<style lang="less" scoped>
.fund-holding-overview {
	.overview-block {
		display: flex;
		justify-content: space-between;
	}
	.overview-item {
		.overview-item-value {
			margin-right: 8px;
			color: var(--t-emphasis-color, #1d2129);
			font-family: 'DIN Alternate';
			font-size: 24px;
			font-weight: 700;
			line-height: 28px; /* 100% */
		}
		.overview-item-label {
			color: var(--t-secondary-info-color, #86909c);
			font-size: 13px;
			font-weight: 400;
			line-height: 20px; /* 153.846% */
		}
	}
}
</style>
